import React from 'react';
import { FC } from 'react';

const Footer: FC = () => {
  return (
    <footer className="bg-gray-800 text-white p-4 text-center">
      <p>© 2024 ParkingSpot Finder. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
